import React, { ComponentProps } from "react";
import { Route, withRouter, RouteComponentProps } from "react-router-dom";

import { fomatParentPath } from "../../utils";
import { MobRecords } from "../../lib";

function Rule(props: RouteComponentProps & ComponentProps<any>) {
  const parentPath: string = fomatParentPath(props);
  return (
    <Route weId={`${props.weId || ""}_y1jtf4`} exact path={`${parentPath}/mobile/uk/recommend/records`}>
      {<MobRecords weId={`${props.weId || ""}_y6vtw3`} />}
    </Route>
  );
}

export default withRouter(Rule);
